import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/features/marketing/content/content-page";
import { body } from "@/features/marketing/content/pages/guide-wedding-budget-breakdown";
import { SEO } from "@/features/marketing/seo";

export const Route = createFileRoute("/_marketing/guides/wedding-budget-breakdown")({
  head: SEO["/guides/wedding-budget-breakdown"],
  component: () => <ContentPage path="/guides/wedding-budget-breakdown" body={body} />,
});
